import './index.css';
import "antd/dist/antd.css";
import "moment/locale/pt-br";

import React from 'react';
import ReactDOM from 'react-dom';

import axios from 'axios';
import App from './App';
// import registerServiceWorker from './registerServiceWorker';
import { getToken } from './utils/LoginManager'

axios.defaults.baseURL = process.env.REACT_APP_URL_API;

// if (process.env.NODE_ENV === 'development') {
//     axios.defaults.baseURL = 'http://fastgestor.local/api';
// } else {
//     axios.defaults.baseURL = 'https://plenasistemas.inf.br/fastgestor/public/api';
// }

axios.interceptors.request.use(request => {
    request.headers.Authorization = 'Bearer ' + getToken();     
    return request;
})

ReactDOM.render(<App />, document.getElementById('root'));
// registerServiceWorker();



// WEBPACK FOOTER //
// ./src/index.js